import ComponentLoader from 'components/ComponentLoader'
import { ORDER_MODEL_STATUSES_LABEL } from 'models/daos/order/constants/index.cjs'
import {
  ROUTE,
  ROUTE_PATH
} from 'modules/routes/constants/index.cjs'
import React from 'react'
import {
  Route,
  Routes
} from 'react-router-dom'
import getSearchPageComponentRouteUtil from 'modules/routes/utils/search/get-component'
import WithRouteAndMatch from 'components/WithRouteAndMatch'
import getSectionComponentRouteUtil from 'modules/routes/utils/routes/get-section'
import getCategoryOrItemComponentUtil from 'modules/routes/utils/get-category-or-item-component/index.js'
import getWorkoutComponentRouteUtil from 'modules/routes/utils/get-workout-component/index.js'
import getPlanWorkoutComponentRouteUtil from 'modules/routes/utils/get-plan-workout-component/index.js'
import getWorkoutsComponentRouteUtil from 'modules/routes/utils/get-workouts-component/index.js'
import getPlansComponentRouteUtil from 'modules/routes/utils/get-plans-component/index.js'
import getExercisesComponentRouteUtil from 'modules/routes/utils/get-exercises-component/index.js'
import getExerciseComponentRouteUtil from 'modules/routes/utils/get-exercise-component/index.js'

function importEditComponent () {
  return import(/* webpackChunkName: "containers/Edit" */ 'containers/Edit')
}

function importArticleComponent () {
  return import(/* webpackChunkName: "pages/Article" */ 'pages/Article')
}

function importArticleNewFromTextComponent () {
  return import(/* webpackChunkName: "pages/ArticleNewFromText" */ 'pages/ArticleNewFromText')
}

function importCheckoutComponent () {
  return import(/* webpackChunkName: "containers/Checkout" */ 'containers/Checkout')
}

function loadHome () {
  return import(/* webpackChunkName: "pages/Home" */ 'pages/Home')
}

function loadContact () {
  return import(/* webpackChunkName: "containers/Contact" */ 'containers/Contact')
}

function loadApp () {
  return import(/* webpackChunkName: "pages/App" */ 'pages/App')
}

function loadTrackCalories () {
  return import(/* webpackChunkName: "pages/TrackCalories" */ 'pages/TrackCalories')
}

function loadCheckExerciseForm () {
  return import(/* webpackChunkName: "pages/CheckExerciseForm" */ 'pages/CheckExerciseForm')
}

function loadCheckExerciseFormSlug () {
  return import(/* webpackChunkName: "pages/CheckExerciseFormSlug" */ 'pages/CheckExerciseFormSlug')
}

function loadTools () {
  return import(/* webpackChunkName: "pages/Tools" */ 'pages/Tools')
}

function loadToolsCheckExerciseForm () {
  return import(/* webpackChunkName: "pages/ToolsCheckExerciseForm" */ 'pages/ToolsCheckExerciseForm')
}

function loadLog () {
  return import(/* webpackChunkName: "containers/Log" */ 'containers/Log')
}

function loadLogs () {
  return import(/* webpackChunkName: "containers/Logs" */ 'containers/Logs')
}

function loadOrders () {
  return import(/* webpackChunkName: "containers/Orders/Orders" */ 'containers/Orders')
}

function loadOrder () {
  return import(/* webpackChunkName: "containers/Order/Order" */ 'containers/Order')
}

// function loadCoaching () {
//   return import(/* webpackChunkName: "modules/training/modules/coaching/containers" */ 'modules/coaching/components')
// }
//
// function loadCoachingPayment () {
//   return import(/* webpackChunkName: "modules/training/modules/coaching/containers/Payment" */ 'modules/coaching/components/Payment')
// }

// function loadCoachClientInvitation () {
//   return import(/* webpackChunkName: "modules/training/modules/coaching/containers/ClientAcceptInvitation" */ 'modules/coaching/components/ClientAcceptInvitation')
// }

function getHomeComponent (props) {
  if (HOME || (SERVER && global.HOME)) {
    const Component = require('pages/Home').default
    return <Component {...props} />
  } else {
    return (
      <ComponentLoader
        loadComponent={loadHome}
        {...props}
      />
    )
  }
}

function getPlanComponent (props) {
  if (PLAN || (SERVER && global.PLAN)) {
    const Plan = require(
      'pages/Plan').default
    return <Plan {...props} />
  } else {
    return (
      <ComponentLoader
        loadComponent={importPlanComponent}
        {...props}
      />
    )
  }
}

function getContactComponent (props) {
  if (CONTACT || (SERVER && global.CONTACT)) {
    const Contact = require('containers/Contact').default
    return <Contact {...props} />
  } else {
    return (
      <ComponentLoader
        loadComponent={loadContact}
        {...props}
      />
    )
  }
}

function getAppComponent (props) {
  if (APP || (SERVER && global.APP)) {
    const App = require('pages/App').default
    return <App {...props} />
  } else {
    return (
      <ComponentLoader
        loadComponent={loadApp}
        {...props}
      />
    )
  }
}

function getTrackCaloriesComponent (props) {
  if (typeof TRACK_CALORIES !== 'undefined' || (SERVER && global.TRACK_CALORIES)) {
    const TrackCalories = require('pages/TrackCalories').default
    return <TrackCalories {...props} />
  } else {
    return (
      <ComponentLoader
        loadComponent={loadTrackCalories}
        {...props}
      />
    )
  }
}

function getCheckExerciseFormComponent (props) {
  if (typeof CHECK_EXERCISE_FORM !== 'undefined' || (SERVER && global.CHECK_EXERCISE_FORM)) {
    const CheckExerciseForm = require('pages/CheckExerciseForm').default
    return <CheckExerciseForm {...props} />
  } else {
    return (
      <ComponentLoader
        loadComponent={loadCheckExerciseForm}
        {...props}
      />
    )
  }
}

function getCheckExerciseFormSlugComponent (props) {
  if (typeof CHECK_EXERCISE_FORM !== 'undefined' || (SERVER && global.CHECK_EXERCISE_FORM)) {
    const CheckExerciseFormSlug = require('pages/CheckExerciseFormSlug').default
    return <CheckExerciseFormSlug {...props} />
  } else {
    return (
      <ComponentLoader
        loadComponent={loadCheckExerciseFormSlug}
        {...props}
      />
    )
  }
}

function getToolsComponent (props) {
  if (typeof TOOLS !== 'undefined' || (SERVER && global.TOOLS)) {
    const Tools = require('pages/Tools').default
    return <Tools {...props} />
  } else {
    return (
      <ComponentLoader
        loadComponent={loadTools}
        {...props}
      />
    )
  }
}

function getToolsCheckExerciseFormComponent (props) {
  if (typeof TOOLS !== 'undefined' || (SERVER && global.TOOLS)) {
    const ToolsCheckExerciseForm = require('pages/ToolsCheckExerciseForm').default
    return <ToolsCheckExerciseForm {...props} />
  } else {
    return (
      <ComponentLoader
        loadComponent={loadToolsCheckExerciseForm}
        {...props}
      />
    )
  }
}

function importProfileComponent () {
  return import(/* webpackChunkName: "containers/Profile" */ 'containers/Profile')
}

function importPlanComponent () {
  return import(/* webpackChunkName: "pages/Plan" */ 'pages/Plan')
}

function importVerifyEmailComponent () {
  return import(/* webpackChunkName: "containers/VerifyEmail" */ 'containers/VerifyEmail')
}

function importChangePasswordComponent () {
  return import(/* webpackChunkName: "containers/ChangePassword" */ 'containers/ChangePassword')
}

function importSigninComponent () {
  return import(/* webpackChunkName: "containers/Signin" */ 'containers/Signin')
}

/**
 * A mapping of route path to component
 * @type {Object}
 */
const ROUTE_PATH_TO_COMPONENT = {
  // Coaching
  // [ROUTE_PATH.APP_COACH_INVITATION]: addAsyncRoute.bind(
  //   null,
  //   loadCoachClientInvitation
  // ),
  // [ROUTE_PATH.COACHING]: addAsyncRoute.bind(
  //   null,
  //   loadCoaching
  // ),
  // [ROUTE_PATH.COACHING_PAYMENT]: addAsyncRoute.bind(
  //   null,
  //   loadCoachingPayment
  // ),
  //
  // App
  [ROUTE_PATH.APP_DEEP_LINK_OPEN]: addAsyncRoute.bind(
    null,
    () => import(/* webpackChunkName: "modules/training/modules/app/containers/AppDeepLinkOpen" */ 'modules/training/modules/app/containers/AppDeepLinkOpen')
  ),

  // Articles
  [ROUTE_PATH.ARTICLES]: getSectionComponentRouteUtil,
  [ROUTE_PATH.CONTACT]: getContactComponent,
  [ROUTE_PATH.ARTICLES_NEW]: addAsyncRoute.bind(
    null,
    importEditComponent
  ),
  [ROUTE_PATH.ARTICLES_NEW_FROM_TEXT]: addAsyncRoute.bind(
    null,
    importArticleNewFromTextComponent
  ),
  [ROUTE_PATH.ARTICLES_EDIT]: addAsyncRoute.bind(
    null,
    importEditComponent
  ),
  [ROUTE_PATH.ARTICLES_BY_CATEGORY_OR_SLUG]: getCategoryOrItemComponentUtil,
  [ROUTE_PATH.ARTICLES_BY_CATEGORY_OR_SLUG_EDIT]: addAsyncRoute.bind(
    null,
    importEditComponent
  ),

  // Cart
  [ROUTE_PATH.CART]: addAsyncRoute.bind(
    null,
    importCheckoutComponent
  ),

  // Categories
  [ROUTE_PATH.CATEGORY_NEW]: addAsyncRoute.bind(
    null,
    importEditComponent
  ),
  [ROUTE_PATH.CATEGORY_EDIT]: addAsyncRoute.bind(
    null,
    importEditComponent
  ),

  // Checkout
  [ROUTE_PATH.CHECKOUT]: addAsyncRoute.bind(
    null,
    importCheckoutComponent
  ),

  // Company
  [ROUTE_PATH.COMPANY]: getSectionComponentRouteUtil,
  [ROUTE_PATH.COMPANY_EDIT]: addAsyncRoute.bind(
    null,
    importEditComponent
  ),
  [ROUTE_PATH.COMPANY_BY_SLUG]: addAsyncRoute.bind(
    null,
    importArticleComponent
  ),
  [ROUTE_PATH.COMPANY_BY_SLUG_EDIT]: addAsyncRoute.bind(
    null,
    importEditComponent
  ),
  [ROUTE_PATH.LINKS]: addAsyncRoute.bind(
    null,
    importArticleComponent
  ),
  [ROUTE_PATH.LINKS_EDIT]: addAsyncRoute.bind(
    null,
    importEditComponent
  ),
  // Email templates
  [ROUTE_PATH.EMAIL_TEMPLATES]: getSectionComponentRouteUtil,
  [ROUTE_PATH.EMAIL_TEMPLATES_NEW]: addAsyncRoute.bind(
    null,
    importEditComponent
  ),
  [ROUTE_PATH.EMAIL_TEMPLATES_EDIT]: addAsyncRoute.bind(
    null,
    importEditComponent
  ),
  [ROUTE_PATH.EMAIL_TEMPLATES_BY_ID]: addAsyncRoute.bind(
    null,
    () => import(/* webpackChunkName: "containers/EmailTemplate" */ 'containers/EmailTemplate')
  ),
  [ROUTE_PATH.EMAIL_TEMPLATES_BY_ID_EDIT]: addAsyncRoute.bind(
    null,
    importEditComponent
  ),

  // Home
  [ROUTE_PATH.HOME]: getHomeComponent,

  // Logs
  [ROUTE_PATH.LOGS]: addAsyncRoute.bind(
    null,
    () => import(/* webpackChunkName: "containers/Logs" */ 'containers/Logs')
  ),
  [ROUTE_PATH.LOGS_BY_USERNAME_OR_ID]: getLogsOrLog,

  // Pages
  [ROUTE_PATH.PAGES_NEW]: addAsyncRoute.bind(
    null,
    importEditComponent
  ),

  // Profile
  [ROUTE_PATH.PROFILE_BY_NAME]: addAsyncRoute.bind(
    null,
    importProfileComponent
  ),
  [ROUTE_PATH.PROFILE_BY_NAME_EDIT]: addAsyncRoute.bind(
    null,
    importProfileComponent
  ),

  // PromoCode
  [ROUTE_PATH.PROMO_CODES_NEW]: addAsyncRoute.bind(
    null,
    importEditComponent
  ),
  [ROUTE_PATH.PROMO_CODES_BY_NAME_EDIT]: addAsyncRoute.bind(
    null,
    importEditComponent
  ),

  // Motivation
  [ROUTE_PATH.MOTIVATION]: getSectionComponentRouteUtil,
  [ROUTE_PATH.MOTIVATION_NEW]: addAsyncRoute.bind(
    null,
    importEditComponent
  ),
  [ROUTE_PATH.MOTIVATION_EDIT]: addAsyncRoute.bind(
    null,
    importEditComponent
  ),
  [ROUTE_PATH.MOTIVATION_BY_CATEGORY_OR_SLUG]: getCategoryOrItemComponentUtil,
  [ROUTE_PATH.MOTIVATION_BY_CATEGORY_OR_SLUG_EDIT]: addAsyncRoute.bind(
    null,
    importEditComponent
  ),

  // New
  [ROUTE_PATH.NEW]: addAsyncRoute.bind(
    null,
    importEditComponent
  ),

  // Notifications
  [ROUTE_PATH.NOTIFICATIONS]: addAsyncRoute.bind(
    null,
    () => import(/* webpackChunkName: "containers/Notifications" */ 'containers/Notifications')
  ),

  // Orders
  [ROUTE_PATH.ORDERS]: addAsyncRoute.bind(
    null,
    () => import(/* webpackChunkName: "containers/Orders" */ 'containers/Orders')
  ),
  [ROUTE_PATH.ORDERS_BY_CATEGORY_OR_KEY]: getOrdersOrOrder,
  [ROUTE_PATH.ORDERS_BY_CATEGORY_OR_KEY_EDIT]: addAsyncRoute.bind(
    null,
    importEditComponent
  ),
  [ROUTE_PATH.RESET_PASSWORD]: addAsyncRoute.bind(
    null,
    () => import(/* webpackChunkName: "containers/ResetPassword" */ 'containers/ResetPassword')
  ),
  [ROUTE_PATH.CHANGE_PASSWORD]: addAsyncRoute.bind(
    null,
    importChangePasswordComponent
  ),
  [ROUTE_PATH.CHANGE_PASSWORD_WITH_TOKEN]: addAsyncRoute.bind(
    null,
    importChangePasswordComponent
  ),
  [ROUTE_PATH.VERIFY_EMAIL]: addAsyncRoute.bind(
    null,
    importVerifyEmailComponent
  ),
  [ROUTE_PATH.VERIFY_EMAIL_WITH_TOKEN]: addAsyncRoute.bind(
    null,
    importVerifyEmailComponent
  ),

  // Search
  [ROUTE_PATH.SEARCH]: getSearchPageComponentRouteUtil,
  [ROUTE_PATH.SEARCH_BY_CATEGORY]: getSearchPageComponentRouteUtil,

  // Signup
  [ROUTE_PATH.SIGNUP]: addAsyncRoute.bind(
    null,
    importSigninComponent
  ),
  [ROUTE_PATH.SIGNIN]: addAsyncRoute.bind(
    null,
    importSigninComponent
  ),

  // Store
  [ROUTE_PATH.STORE]: getSectionComponentRouteUtil,
  [ROUTE_PATH.STORE_NEW]: addAsyncRoute.bind(
    null,
    importEditComponent
  ),
  [ROUTE_PATH.STORE_EDIT]: addAsyncRoute.bind(
    null,
    importEditComponent
  ),
  [ROUTE_PATH.STORE_CATEGORY_OR_SLUG]: getCategoryOrItemComponentUtil,
  [ROUTE_PATH.STORE_CATEGORY_OR_SLUG_EDIT]: addAsyncRoute.bind(
    null,
    importEditComponent
  ),

  // Support
  [ROUTE_PATH.SUPPORT]: getSectionComponentRouteUtil,
  [ROUTE_PATH.SUPPORT_EDIT]: addAsyncRoute.bind(
    null,
    importEditComponent
  ),
  [ROUTE_PATH.SUPPORT_BY_SLUG]: addAsyncRoute.bind(
    null,
    importArticleComponent
  ),
  [ROUTE_PATH.SUPPORT_BY_SLUG_EDIT]: addAsyncRoute.bind(
    null,
    importEditComponent
  ),

  [ROUTE_PATH.ACCOUNT]: addAsyncRoute.bind(
    null,
    () => import(/* webpackChunkName: "pages/Account" */ 'pages/Account')
  ),

  [ROUTE_PATH.EXERCISES]: getExercisesComponentRouteUtil,
  [ROUTE_PATH.EXERCISES_WITH_MUSCLE]: getExercisesComponentRouteUtil,
  [ROUTE_PATH.EXERCISES_WITH_EQUIPMENT]: getExercisesComponentRouteUtil,
  [ROUTE_PATH.EXERCISES_WITH_TYPES]: getExercisesComponentRouteUtil,
  [ROUTE_PATH.ADD_EXERCISES_LIST]: addAsyncRoute.bind(
    null,
    () => import(/* webpackChunkName: "modules/training/modules/training-exercises/containers/AddExercisesList" */ 'modules/training/modules/training-exercises/containers/AddExercisesList')
  ),
  [ROUTE_PATH.VIEW_EXERCISE]: getExerciseComponentRouteUtil,
  [ROUTE_PATH.VIEW_EXERCISE_SLUG]: getExerciseComponentRouteUtil,

  [ROUTE_PATH.PLANS_BY_TAG]: getPlansComponentRouteUtil,
  [ROUTE_PATH.PLANS]: getPlansComponentRouteUtil,
  [ROUTE_PATH.PLAN_BY_ID]: getPlanComponent,
  [ROUTE_PATH.PLAN_BY_ID_SLUG]: getPlanComponent,
  [ROUTE_PATH.PLAN_WORKOUT_BY_ID_SLUG]: getPlanWorkoutComponentRouteUtil,

  [ROUTE_PATH.CAREERS]: addAsyncRoute.bind(
    null,
    () => import(/* webpackChunkName: "pages/Careers" */ 'pages/Careers')
  ),
  [ROUTE_PATH.CREATOR_LOGIN]: addAsyncRoute.bind(
    null,
    () => import(/* webpackChunkName: "pages/CreatorSignup" */ 'pages/CreatorSignup')
  ),
  [ROUTE_PATH.CREATOR_PROFILE]: addAsyncRoute.bind(
    null,
    () => import(/* webpackChunkName: "pages/Creator" */ 'pages/Creator')
  ),
  [ROUTE_PATH.CREATOR_PROFILE_SHORT]: addAsyncRoute.bind(
    null,
    () => import(/* webpackChunkName: "pages/Creator" */ 'pages/Creator')
  ),
  [ROUTE_PATH.ACCOUNT_EDIT]: addAsyncRoute.bind(
    null,
    () => import(/* webpackChunkName: "pages/Creator" */ 'pages/Creator/User/EditAccount')
  ),
  [ROUTE_PATH.CREATOR_CHAT]: addAsyncRoute.bind(
    null,
    () => import(/* webpackChunkName: "modules/training/modules/chat/containers/Chat" */ 'modules/training/modules/chat/containers/Chat')
  ),
  [ROUTE_PATH.CREATOR_LANDING]: addAsyncRoute.bind(
    null,
    () => import(/* webpackChunkName: "pages/Creator/Landing" */ 'pages/Creator/Landing')
  ),
  [ROUTE_PATH.CREATOR_WORKOUT]: addAsyncRoute.bind(
    null,
    () => import(/* webpackChunkName: "pages/Creator/Workout" */ 'pages/Creator/Workout')
  ),
  [ROUTE_PATH.CREATE_EXERCISE]: addAsyncRoute.bind(
    null,
    () => import(/* webpackChunkName: "modules/training/modules/training-exercises/containers/CreateExercise" */ 'modules/training/modules/training-exercises/containers/CreateExercise')
  ),
  [ROUTE_PATH.ADD_EXERCISE]: addAsyncRoute.bind(
    null,
    () => import(/* webpackChunkName: "modules/training/modules/training-exercises/containers/AddExercise" */ 'modules/training/modules/training-exercises/containers/AddExercise')
  ),
  [ROUTE_PATH.CAREERS_ROLE]: addAsyncRoute.bind(
    null,
    () => import(/* webpackChunkName: "pages/Careers/Role.js" */ 'pages/Careers/Role.js')
  ),

  [ROUTE_PATH.APP]: getAppComponent,
  [ROUTE_PATH.TRACK_CALORIES]: getTrackCaloriesComponent,
  [ROUTE_PATH.CHECK_EXERCISE_FORM]: getCheckExerciseFormComponent,
  [ROUTE_PATH.CHECK_EXERCISE_FORM_SLUG]: getCheckExerciseFormSlugComponent,
  [ROUTE_PATH.TOOLS]: getToolsComponent,
  [ROUTE_PATH.TOOLS_CHECK_EXERCISE_FORM]: getToolsCheckExerciseFormComponent,
  [ROUTE_PATH.PRIVACY]: addAsyncRoute.bind(
    null,
    () => import(/* webpackChunkName: "pages/Privacy" */ 'pages/Privacy')
  ),
  [ROUTE_PATH.PREMIUM]: addAsyncRoute.bind(
    null,
    () => import(/* webpackChunkName: "pages/Premium" */ 'pages/Premium')
  ),
  [ROUTE_PATH.APP_TERMS]: addAsyncRoute.bind(
    null,
    () => import(/* webpackChunkName: "pages/Terms" */ 'pages/Terms')
  ),
  [ROUTE_PATH.FAQ]: addAsyncRoute.bind(
    null,
    () => import(/* webpackChunkName: "pages/Faq" */ 'pages/Faq')
  ),
  [ROUTE_PATH.APP_CHALLENGE]: addAsyncRoute.bind(
    null,
    () => import(/* webpackChunkName: "pages/App/Challenge" */ 'pages/Challenge')
  ),
  [ROUTE_PATH.EXERCISES_EDIT]: addAsyncRoute.bind(
    null,
    () => import(/* webpackChunkName: "pages/App/ExerciseEdit" */ 'pages/ExerciseEdit')
  ),
  [ROUTE_PATH.CREATOR]: addAsyncRoute.bind(
    null,
    () => import(/* webpackChunkName: "pages/Landing" */ 'pages/Creators')
  ),
  [ROUTE_PATH.REPORT]: addAsyncRoute.bind(
    null,
    () => import(/* webpackChunkName: "pages/Report" */ 'pages/Report')
  ),
  [ROUTE_PATH.NOT_FOUND]: addAsyncRoute.bind(
    null,
    () => import(/* webpackChunkName: "components/NotFound" */ 'components/NotFound')
  ),

  [ROUTE_PATH.START_WORKOUT]: addAsyncRoute.bind(
    null,
    () => import(/* webpackChunkName: "modules/workout/redux/containers/StartWorkout" */ 'pages/StartWorkout')
  ),

  [ROUTE_PATH.WORKOUT_SHARED_BY_SHARE_KEY]: addAsyncRoute.bind(
    null,
    () => import(/* webpackChunkName: "modules/training/modules/training-workouts/containers/WorkoutShared" */ 'pages/WorkoutShared')
  ),
  [ROUTE_PATH.WORKOUT_BY_ID_SLUG]: getWorkoutComponentRouteUtil,
  [ROUTE_PATH.WORKOUT_COMPLETED]: addAsyncRoute.bind(
    null,
    () => import(/* webpackChunkName: "modules/workout/redux/containers/WorkoutCompleted" */ 'pages/WorkoutCompleted')
  ),
  [ROUTE_PATH.WORKOUT_ACHIEVEMENTS]: addAsyncRoute.bind(
    null,
    () => import(/* webpackChunkName: "pages/WorkoutAchievements" */ 'pages/WorkoutAchievements')
  ),
  [ROUTE_PATH.WORKOUT_BY_ID]: getWorkoutComponentRouteUtil,
  [ROUTE_PATH.WORKOUTS]: getWorkoutsComponentRouteUtil,
  [ROUTE_PATH.WORKOUTS_BY_TAG]: getWorkoutsComponentRouteUtil

}

function addAsyncRoute (
  importModuleFuncPromise,
  props
) {
  return (
    <ComponentLoader
      loadComponent={importModuleFuncPromise}
      {...props}
    />
  )
}

function getLogsOrLog (props) {
  const { pathname } = props.match
  const usernameOrId = pathname.slice(pathname.lastIndexOf('/') + 1)
  if (!isNaN(usernameOrId)) {
    return (
      <ComponentLoader
        loadComponent={loadLog}
        {...props}
      />
    )
  }
  return (
    <ComponentLoader
      loadComponent={loadLogs}
      {...props}
    />
  )
}

function getOrdersOrOrder (props) {
  const { pathname } = props.match
  const categoryOrKey = pathname.slice(pathname.lastIndexOf('/') + 1)
  if (ORDER_MODEL_STATUSES_LABEL.includes(categoryOrKey)) {
    return (
      <ComponentLoader
        loadComponent={loadOrders}
        {...props}
      />
    )
  }
  return (
    <ComponentLoader
      loadComponent={loadOrder}
      {...props}
    />
  )
}

/**
 * Returns a react router's switch containing all the routes.
 * @returns {ReactElement}
 */
function routes () {
  return (
    <Routes>
      {/* Redirects */}
      {/* <Redirect exact from={ROUTE_PATH.CREATOR} to={ROUTE_PATH.ACCOUNT} /> */}
      {/* <Redirect exact from={ROUTE_PATH.EXERCISES + '/muscles'} to={ROUTE_PATH.EXERCISES} /> */}
      {/* <Redirect exact from={ROUTE_PATH.EXERCISES + '/equipment'} to={ROUTE_PATH.EXERCISES} /> */}
      {/* <Redirect exact from={ROUTE_PATH.EXERCISES + '/types'} to={ROUTE_PATH.EXERCISES} /> */}
      {
        Object
          .keys(ROUTE_PATH_TO_COMPONENT)
          .map(path => {
            const route = ROUTE[path]
            const Component = WithRouteAndMatch(ROUTE_PATH_TO_COMPONENT[path])
            return (
              <Route
                key={path || 'notFound'}
                path={path}
                element={<Component route={route} />}
              />
            )
          })
      }
    </Routes>
  )
}

export default routes
export {
  importCheckoutComponent
}
